import api from '../api'

const state = {
  user: null
}

const actions = {
  getProfileUser: ({ state, commit }) => {
    return api.getCurrentUser().then(user => {
      return commit('setCurrentUser', user)
    })
  }
}

const mutations = {
  setCurrentUser (state, user) {
    state.user = user
  }
}

const getters = {
  user: state => {
    return state.user
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/profile.js